module.exports = __webpack_public_path__ + "static/media/az-15.502229bd.jpg";